import React from 'react'
import ReactDOM from 'react-dom';

let cancelScrollEvent = function (e) {
  e.stopImmediatePropagation();
  e.preventDefault();
  e.returnValue = false;
  return false;
};

let addScrollEventListener = function (node, handler) {
  node.addEventListener('wheel', handler, false);
};

let removeScrollEventListener = function (node, handler) {
  node.removeEventListener('wheel', handler, false);
};

export default class ScrollView extends React.Component {

  componentDidMount() {
    this.scrollRemove = this.scrollLock();
  }

  componentWillUnmount() {
    this.scrollRemove();
  }

  scrollLock(node) {
    node = node || ReactDOM.findDOMNode(this);
    this.scrollNode = node;
    addScrollEventListener(node, this.onScrollHandler);
    return (el) => {
      el = el || this.scrollNode;
      removeScrollEventListener(el, this.onScrollHandler);
    };
  }

  onScrollHandler(e) {
    let node = this;
    let scrollTop = node.scrollTop;
    let scrollHeight = node.scrollHeight;
    let height = node.clientHeight;
    let wheelDelta = e.deltaY;
    let isDeltaPositive = wheelDelta > 0;

    if (isDeltaPositive && wheelDelta > scrollHeight - height - scrollTop) {
      node.scrollTop = scrollHeight;
      return cancelScrollEvent(e);
    }
    else if (!isDeltaPositive && -wheelDelta > scrollTop) {
      node.scrollTop = 0;
      return cancelScrollEvent(e);
    }
  }

  render() {
    const {children, className, element} = this.props;

    switch (element) {
      case 'table-body':
        return (
          <tbody className={className}>
            {children}
          </tbody>
        );
      default:
        return (
          <ul>
            {children}
          </ul>
        );
    }
  }
}

ScrollView.defaultProps = {
  className: ''
};
